<template>
  <div>
    <div class="d-flex justify-content-end mb-2">
      <div class="d-flex align-items-center flex-wrap">
        <div>
          <img
            class="cursor-pointer mx-1"
            :style="`opacity:${selected_tab === 'map' ? 1 : 0.3}`"
            :src="require('@/assets/images/icons/list-icon.svg')"
            alt="list"
            @click.stop="selectTab('map')"
          />
        </div>
        <div>
          <img
            class="cursor-pointer mx-1"
            :style="`opacity:${selected_tab === 'reports' ? 1 : 0.3}`"
            :src="require('@/assets/images/icons/calendar-icon.svg')"
            alt="grid"
            @click.stop="selectTab('reports')"
          />
        </div>
      </div>
    </div>
    <cus-map v-if="selected_tab === 'map'" />
    <reports v-else-if="selected_tab === 'reports'" />
    <div v-else class="title d-flex align-items-center justify-content-center">
      {{ $t('no-view-found') }}
    </div>
  </div>
</template>

<script>
import CusMap from './custom_index.vue'
import Reports from './vue_charts_ops.vue'

export default {
  components: { CusMap, Reports },
  data() {
    return {
      selected_tab: 'map',
    }
  },
  methods: {
    selectTab(tab) {
      const currentPathArray = this.$route?.path?.split('/')
      if (currentPathArray[currentPathArray?.length - 1] !== tab) {
        this.$router.push(`/dashboard/${tab}`).catch(() => {})
      }
    },
    
    normalizeTab(view) {
      return view === 'reports' ? 'reports' : 'map'
    },
    handleMessage(event) {
      if (event.data?.type === 'CHANGE_TAB') {
        this.selected_tab = this.normalizeTab(event.data.view)
      }
    },
  },
  watch: {
    $route(val) {
      if (val?.params?.view) {
        this.selected_tab = this.normalizeTab(val.params.view)
      }
    },
  },
  mounted() {
    if (this.$route?.params?.view) {
      this.selected_tab = this.normalizeTab(this.$route.params.view)
    }
    const token = localStorage.getItem('access_token')

    if (token) {
      this.authReady = true
    }

    window.parent.postMessage({ type: 'IFRAME_READY' }, '*')

    window.addEventListener('message', this.handleMessage)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage)
  },
}
</script>